export default {"src":"/_next/static/media/io.d6ada388.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};